export const listOfPoints = [
  {
    id: 1,
    name: "contenitori",
    top: "62",
    left: "20",
  },
  {
    id: 2,
    name: "boiserie",
    top: "37",
    left: "4",
  },
  {
    id: 3,
    name: "librerie",
    top: "6",
    left: "32",
  },
  {
    id: 4,
    name: "sistemaUniko",
    top: "12",
    left: "91",
  },
  {
    id: 5,
    name: "cabine",
    top: "74",
    left: "82",
  },
  {
    id: 6,
    name: "armadi",
    top: "87",
    left: "68",
  },
];
